import React from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { useAi } from "../context/AiContext";
import { useTranslate } from "../context/TranslateContext";

// Human-readable page context for the assistant, derived from the current route.
const pageContext = (pathname) => {
  if (pathname === "/") return "the IndiasCinema.com home page";
  const seg = pathname.split("/").filter(Boolean);
  const map = {
    movies: "the Movies browse page", movie: "a movie detail page",
    person: "a person / artist profile", song: "a song detail page", album: "a music album page",
    charts: "the CinemaPulse charts page", television: "the Television page", "tv-serials": "the TV Serials page",
    ott: "the OTT / streaming page", explore: "the AI Deep Dives page", library: "the Community Library",
    landmark: "a landmark serial page", article: "an editorial article page", locations: "the film locations page",
    "release-calendar": "the release calendar", "my-cinema": "the user's My Cinema page",
  };
  return map[seg[0]] || "IndiasCinema.com";
};

// Always-available floating "Ask AI" button — sits bottom-left on every page and opens
// the Cinema Concierge with the current page as context.
export const FloatingAskAI = () => {
  const { openAi } = useAi();
  const { t } = useTranslate();
  const { pathname } = useLocation();

  return (
    <motion.button
      data-testid="floating-ask-ai"
      onClick={() => openAi(null, pageContext(pathname))}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, type: "spring", stiffness: 300, damping: 26 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.96 }}
      aria-label={t("Ask AI")}
      className="fixed bottom-5 left-5 z-[60] flex items-center gap-2 rounded-full border border-gold/40 bg-paper/95 py-2.5 pl-3 pr-4 shadow-[0_10px_40px_-8px_rgba(0,0,0,0.4)] backdrop-blur-xl transition-colors hover:border-gold"
    >
      <span className="relative flex h-8 w-8 items-center justify-center rounded-full bg-gold/15">
        <Sparkles className="h-4 w-4 text-gold" />
        <span className="absolute inset-0 rounded-full ring-2 ring-gold/30 animate-ping" style={{ animationDuration: "2.4s" }} />
      </span>
      <span className="font-body text-sm font-medium text-cream">{t("Ask AI")}</span>
    </motion.button>
  );
};
